package org.moxultimate.topwithmox.di

import org.koin.core.module.Module
import org.koin.dsl.module
import org.moxultimate.topwithmox.apps.di.appsModule
import org.moxultimate.topwithmox.appscrud.module.appsCRUDModule
import org.moxultimate.topwithmox.shows.di.showsModule
import org.moxultimate.topwithmox.showscrud.module.showsCRUDModule
import org.moxultimate.topwithmox.architecture.di.architectureModule
import org.moxultimate.topwithmox.product.di.productModule
import org.moxultimate.topwithmox.productcrud.di.productCRUDModule
import org.moxultimate.topwithmox.tech.di.techModule
import org.moxultimate.topwithmox.techcrud.module.techCRUDModule
import org.moxultimate.topwithmox.wallpaper.di.wallpaperModule
import org.moxultimate.topwithmox.wallpapercrud.module.wallpaperCRUDModule
import org.moxultimate.topwithmox.dashboard.di.dashboardModule

/**
 * Root Koin module that aggregates all feature modules.
 *
 * How to add a new feature:
 *   1. Create a `<feature>Module` in the relevant feature package.
 *   2. Include it here with `includes(<feature>Module)`.
 *
 * Keep this file as a thin aggregator — define bindings inside each
 * feature's own module file, not here.
 */
val appModule: Module = module {
    includes(
        sampleModule,
        architectureModule,
        wallpaperModule,
        wallpaperCRUDModule,
        productModule,
        productCRUDModule,
        appsModule,
        appsCRUDModule,
        showsModule,
        showsCRUDModule,
        techModule,
        techCRUDModule,
        dashboardModule,
        // add new feature modules here
    )
}
